import { render, staticRenderFns } from "./FrontendTechReq.vue?vue&type=template&id=03b2ab56&"
import script from "./FrontendTechReq.vue?vue&type=script&lang=js&"
export * from "./FrontendTechReq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports